import { Component, inject, model, output } from '@angular/core';
import { Router } from '@angular/router';
import { BranchService } from '../../../service/branch.service';
import { NotifyService } from '../../../service/notify.service';
import { PanoptycAdminService } from '../../../service/panoptyc-admin.service';
import { Branch } from '../../../types';

@Component({
  selector: 'app-bl-management-branch',
  templateUrl: './bl-management-branch.component.html',
  styleUrls: ['./bl-management-branch.component.scss'],
  standalone: false,
  providers: [],
})
export class BlManagementBranchComponent {
  private adminService = inject(PanoptycAdminService);
  private branchService = inject(BranchService);
  private notifyService = inject(NotifyService);
  private router = inject(Router);

  public branch = model.required<Branch>();
  public loadSubpage = output<string>();

  onBranchUpdate({ id, updatedBranch }: { id: number; updatedBranch?: Branch }) {
    const setBranch = (branch: Branch) => {
      this.branch.set(branch);
    };

    if (updatedBranch) {
      setBranch(updatedBranch);
      return;
    }

    this.branchService
      .getBranchById(id, {
        include_kiosk_providers: true,
      })
      .subscribe({
        next: (branch) => setBranch(branch),
        error: () => this.notifyService.notify(`Failed to load updated branch ${id}`),
      });
  }

  handleBranchNameSave(event) {
    const newName = event.trim();
    if (!newName) return;

    this.adminService.renameBranch(this.branch().id, newName).subscribe(() => {
      this.branch.update((b) => {
        b.name = newName;
        return b;
      });
    });
  }

  deleteBranch() {
    this.adminService.deleteBranch(this.branch().id).subscribe(() => {
      this.router.navigate(['/home', 'manage', 'branch']);
    });
  }
}
